<div id="notfound">
    <div class="notfound">
        <div class="notfound-404">
            <h3>Gotcha! Access Forbidden</h3>
            <h1><span>4</span><span>0</span><span>1</span></h1>
        </div>
        <h2>we are sorry, you are not authorized</h2>
    </div>
</div>